import axios from "axios";
import { serviceBaseUrl } from "./constants";

export const getCurrentSeason = async () => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/publicCurrentSeason`);
    return response.data;
  } catch (error) {
    console.error("Error fetching seasons:", error);
    throw error;
  }
};

export const getAllGroupedTeams = async () => {
    try {
      const response = await axios.get(`${serviceBaseUrl}/publicGroupedTeams`);
      return response.data;
    } catch (error) {
      console.error("Error fetching seasons:", error);
      throw error;
    }
  };

export const getMatchSetups = async () => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/publicMatchSetups`);
    return response.data;
  } catch (error) {
    console.error("Error fetching match setups:", error);
    throw error;
  }
}

export const getGroups = async () => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/groups`);
    return response.data;
  } catch (error) {
    console.error("Error fetching groups:", error);
    throw error;
  }
}